// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3tySV","label":"Category_label__11cMF","content":"Category_content__1Wycu","header":"Category_header__1yPND","location":"Category_location__2hDLZ"};